export const LoveIcon = () => {
  return (
    <svg
      width="65"
      height="53"
      viewBox="0 0 65 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M60.6059 27.5023L44.7836 46.2465C41.709 49.9431 37.1489 52.0809 32.3398 52.0809C27.5307 52.0809 22.9708 49.9431 19.8948 46.2465L4.74187 27.9898C2.02788 24.7348 0.646344 20.5721 0.871091 16.3409C1.09725 12.108 2.91423 8.11773 5.95988 5.17001C9.25457 2.13359 13.6662 0.611688 18.1299 0.970814C22.6135 1.29784 26.7485 3.50907 29.51 7.056L32.6748 10.829L35.3521 7.60306C37.9851 4.2824 41.7796 2.08356 45.9698 1.45059C50.16 0.819457 54.4343 1.79901 57.9289 4.19512C61.3779 6.93356 63.5724 10.9512 64.0141 15.3323C64.5887 19.6845 63.357 24.0824 60.6064 27.5023H60.6059Z"
        fill="white"
      />
    </svg>
  );
};
